import * as echarts from "echarts"
import { useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"

import type { HomeStats } from "@/types/homeTypes"

function SinglePieChart({
  title,
  value,
  color,
}: {
  title: string
  value: number
  color: string
}) {
  const chartRef = useRef(null)
  const { t } = useTranslation()

  useEffect(() => {
    const chart = echarts.init(chartRef.current)

    const option = {
      title: {
        text: `${value}%`,
        subtext: title,
        left: "center",
        top: "40%",
        textStyle: {
          fontSize: 18,
          fontWeight: "bold",
        },
        subtextStyle: {
          fontSize: 12,
          color: "#666",
        },
      },
      tooltip: {
        trigger: "item",
        formatter: `{b}: {c}%`,
      },
      series: [
        {
          name: title,
          type: "pie",
          radius: ["60%", "80%"],
          avoidLabelOverlap: false,
          label: {
            show: false,
          },
          labelLine: {
            show: false,
          },
          data: [
            { value, name: title, itemStyle: { color } },
            {
              value: 100 - value,
              name: t("homePage.leaderboard.roundStats.remaining"),
              itemStyle: { color: "#eee" },
            },
          ],
        },
      ],
    }

    chart.setOption(option)
    return () => chart.dispose()
  }, [title, value, color, t])

  return (
    <div
      ref={chartRef}
      style={{
        width: "100%",
        maxWidth: "250px", // حجم مناسب على الموبايل
        height: "200px",
        margin: "0 auto", // توسيط العنصر
      }}
    />
  )
}

export default function RoundStatsCharts({ stats }: { stats: HomeStats }) {
  const { t } = useTranslation()
  return (
    <div className="row">
      <div className="col-12 col-md-3 col-lg-3 mb-4 d-flex justify-content-center">
        <SinglePieChart
          title={t("homePage.leaderboard.roundStats.attendancePieChartTitle")}
          value={stats?.attendance_rate || 0}
          color="#07c392"
        />
      </div>

      <div className="col-12 col-md-3 col-lg-3 mb-4 d-flex justify-content-center">
        <SinglePieChart
          title={t("homePage.leaderboard.roundStats.avgRatingPieChartTitle")}
          value={stats?.average_rating || 0}
          color="#ffb800"
        />
      </div>
      <div className="col-12 col-md-3 col-lg-3 mb-4 d-flex justify-content-center">
        <SinglePieChart
          title={t("homePage.leaderboard.roundStats.scorePieChartTitle")}
          value={stats?.score || 0}
          color="#1890ff"
        />
      </div>
      <div className="col-12 col-md-3 col-lg-3 mb-4 d-flex justify-content-center">
        <SinglePieChart
          title={t("homePage.leaderboard.roundStats.bonusPieChartTitle")}
          value={(stats?.bonus || 0) * 10}
          color="#ff4d4f"
        />
      </div>
    </div>
  )
}
